'use client'

import * as SolidIcon from '@heroicons/react/20/solid'
import * as OutlineIcon from '@heroicons/react/24/outline'
import { type ReactNode } from 'react'

import { cn } from '@src/utils/tailwind'

export const IconNames = ['CheckCircleIcon', 'CheckIcon'] as const

export const IconTypes = ['outline', 'solid'] as const

interface IconTextProps {
  children: ReactNode
  iconName: (typeof IconNames)[number]
  iconType?: (typeof IconTypes)[number]
  iconColor?: string
  iconSize?: number
  className?: string
}

export const IconText = (props: IconTextProps) => {
  const {
    children,
    iconName = 'CheckCircleIcon',
    iconColor = '#131232',
    iconType = 'solid',
    iconSize = 16,
    className,
  } = props
  const IconComponent = iconType === 'outline' ? OutlineIcon[iconName] : SolidIcon[iconName]
  return (
    <div className={cn('relative flex items-center gap-3', className)}>
      <div className="flex items-center justify-center">
        <IconComponent
          style={{ height: `${iconSize}px`, width: `${iconSize}px` }}
          color={iconColor}
        />
      </div>
      {children}
    </div>
  )
}
